import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AvanoPopoverComponent } from "./avano-popover.component";
import { AvanoPopoverDirective } from "./avano-popover.directive";

@NgModule({
  imports: [CommonModule],
  exports: [AvanoPopoverComponent, AvanoPopoverDirective],
  declarations: [AvanoPopoverComponent, AvanoPopoverDirective]
})
export class AvanoPopoverModule {}